import React, { Component } from 'react';
import './App.css';
import qs from 'qs';
import reqwest from 'reqwest';

//const QS_BASE_URL = 'http://localhost:7777/v1/stream-provider/manual';
const QS_BASE_URL = 'https://querystreamer-stage.lcc.infomaker.io/v1/stream-provider/manual';


// ID (name): manual
// Api Token: 22bec815-ab13-4ebb-87ab-92f3baa8101a
// Notify Token: 22bec815-ab13-4ebb-87ab-92f3baa8101a
// Source Type: oc
// Geo Fields: geo_coordinates


class App extends Component {
  constructor(props){
    super(props);

    this.state = {
      publisherId : 'open',
      connected : false,
      messages : [],
      error : '',


      webhookUrl : '',
      destination : null,
      sessionSecret : null,

      webhookPost : `{
        "msg" : "test push"
}`,

      subscribeBroadcastId :'all',
      subscribeFilter : `{

}`,

      unsubscribeBroadcastId : 'all',
      unsubscribeFilter : `{

}`,

      broadcastBroadcastId : 'all',
      broadcastToken : 'not-needed-for-open',
      broadcastData : `{
    "title" : "This is a broadcast"
}`,

      qsQuery : `{
  "query_string" : {
    "query" : ""
  }
}`,
      qsConfig : `{

}`,
      qsMeta : `{
  "info" : "Created by LCC lab"
}`,
      qsLastCreatedStreamId : '',
      qsNotifyData : `{
  "uuid" : "1234",
  "properties" : [{
    "name" : "msg",
    "values" : ["random data ${Math.random()}"]
  }]
}`,

      result : ''
    };
  }

  componentDidMount(){
    this.connect();
  }

  _post(url, data, extraReqPramas, successCallback){
    this.setState({
      result : 'POST in progress...'
    });

    let req = {
      url : url,
      method : 'POST',
      crossOrigin: true,
      error : (err) => {
        console.log('POST err', err);
        this.setState({
          result : `POST fail: ${err.response}`
        });
      },
      success : (res) => {
        console.log('POST res', res);
        this.setState({
          result : `POST success: ${JSON.stringify(res, null, 2)}`
        });
        if(successCallback){
          successCallback(res);
        }
      }
    }

    if(data){
      req.data = data;
      req.contentType = 'application/json';
    }

    if(extraReqPramas){
      Object.assign(req, extraReqPramas);
    }

    reqwest(req);
  }


  _delete(url, data, extraReqPramas, successCallback){
    this.setState({
      result : 'DELETE in progress...'
    });

    let req = {
      url : url,
      method : 'DELETE',
      crossOrigin: true,
      error : (err) => {
        console.log('DELETE err',err);
        this.setState({
          result : `DELETE fail: ${err.response}`
        });
      },
      success : (res) => {
        console.log('DELETE RES:', res);
        this.setState({
          result : `DELETE success: ${JSON.stringify(res, null, 2)}`
        });
        if(successCallback){
          successCallback(res);
        }
      }
    };

    if(data){
      req.data = data;
      req.contentType = 'application/json';
    }

    if(extraReqPramas){
      Object.assign(req, extraReqPramas);
    }

    reqwest(req);
  }



  _buildSubUrl(broadcastId, filter){
    return `${this.state.destination.baseUrl}/v1/instance/${this.state.destination.instanceId}/v1/publisher/${this.state.publisherId}/broadcast/${broadcastId}/subscribe`;
  }

  _buildSubPayload(filter){
    return JSON.stringify({
      sessionId : this.state.destination.sessionId,
      sessionSecret : this.state.sessionSecret,
      filters : [filter]
    })
  }

  _buildBroadcastUrl(){
    return `${this.state.destination.baseUrl}/v1/publisher/${this.state.publisherId}/broadcast/${this.state.broadcastBroadcastId}/publish?token=${this.state.broadcastToken}`;
  }

  postToWebhook(){
    console.log('Post to webhook');
    this._post(this.state.webhookUrl, this.state.webhookPost);
  }

  subscribe(){
    console.log('Subscribe!');
    this._post(this._buildSubUrl(this.state.subscribeBroadcastId), this._buildSubPayload(this.state.subscribeFilter));
  }

  unsubscribe(){
    console.log('Unsubscribe!');
    this._delete(this._buildSubUrl(this.state.unsubscribeBroadcastId), this._buildSubPayload(this.state.unsubscribeFilter));
  }

  broadcast(){
    console.log('Publish to broadcast');
    let publishUrl = this._buildBroadcastUrl();
    this._post(publishUrl, this.state.broadcastData);
  }

  createStream(){
    let createReq = {
      query : JSON.parse(this.state.qsQuery),
      destination : this.state.destination,
      config : JSON.parse(this.state.qsConfig),
      meta : JSON.parse(this.state.qsMeta)
    };
    console.log('Create stream', createReq);
    this._post(`${QS_BASE_URL}/streams`, JSON.stringify(createReq), {
      crossOrigin: true,
      withCredentials: true,
      headers: {
       Authorization : 'Basic ' + btoa('manual' + ':' + '22bec815-ab13-4ebb-87ab-92f3baa8101a')
      }
    }, (res)=>{
      this.setState({
        qsLastCreatedStreamId : res.streamId
      });
    });
  }

  deleteStream(){
    let streamIdToDelete = this.state.qsLastCreatedStreamId;
    console.log('Delete stream', streamIdToDelete);

    this._delete(`${QS_BASE_URL}/streams/${streamIdToDelete}`, null, {
      crossOrigin: true,
      withCredentials: true,
      headers: {
       Authorization : 'Basic ' + btoa('manual' + ':' + '22bec815-ab13-4ebb-87ab-92f3baa8101a')
      }
    }, (res)=>{
      this.setState({
        qsLastCreatedStreamId : ''
      });
    });
  }

  publishToStream(){
    console.log('Publish to QS', this.state.qsNotifyData);
    this._post(`${QS_BASE_URL}/notify`, JSON.stringify(this.state.qsNotifyData), {
      crossOrigin: true,
      withCredentials: true,
      headers: {
       Authorization : 'Basic ' + btoa('manual' + ':' + '22bec815-ab13-4ebb-87ab-92f3baa8101a')
      }
    });
  }

  connect(){
    if(!this.state.connected){
      this.source = new EventSource(`https://infocaster-stage.lcc.infomaker.io/v1/publisher/${this.state.publisherId}/session`);
      this.source.onmessage = (e) => {
        console.log(e.data)

        let parsedData = JSON.parse(e.data);

        if(parsedData.type === 'sessionInit'){
          this.setState({
            webhookUrl : parsedData.data.webhookUrl,
            sessionSecret : parsedData.data.sessionSecret,
            destination : parsedData.data.destination
          });
        }

        let formatedJson = JSON.stringify(parsedData, null, 2);

        this.setState({
          messages : [formatedJson].concat(this.state.messages)
        });
      };


      this.source.onerror = (e) => {
        console.error('EventSource error', e.target.readyState, e, JSON.stringify(e));
        this.setState({
          error : JSON.stringify(e)
        });
      };


      this.source.onopen = (e) => {
        console.info(e);
        this.setState({
          connected : true
        });
      };
    }
  }


  render() {
    return (
      <div className="App">
        <div className="App-header">
          <h2>Live Content Cloud Playground</h2>
        </div>
        <div className="App-intro">
          <section className="con">
              <div className="one">
                <div>
                  <h4>Publish to session</h4>
                    webhookUrl
                    <input className="u-full-width" type="text" value={this.state.webhookUrl}  onChange={(event) => this.setState({webhookUrl: event.target.value})} /><br />
                    JSON data:
                    <textarea className="u-full-width" value={this.state.webhookPost} onChange={(event) => this.setState({webhookPost: event.target.value})} /> <br />
                    <button className="button-primary" onClick={this.postToWebhook.bind(this)}>Publish to session (webhookUrl)</button>
                </div>
                <hr/>
                <div>
                  <h4>Subscribe to broadcast</h4>
                  BroadcastId
                  <input className="u-full-width" type="text" value={this.state.subscribeBroadcastId}  onChange={(event) => this.setState({subscribeBroadcastId: event.target.value})} /><br />
                  Filter: <textarea id="subBroadcastFilter" className="u-full-width" value={this.state.subscribeFilter} onChange={(event) => this.setState({subscribeFilter: event.target.value})} /><br/>
                  <button className="button-primary"  onClick={this.subscribe.bind(this)}>Subscribe</button>
                </div>
                <hr/>
                <div>
                  <h4>Unsubscribe from broadcast</h4>
                  BroadcastId: <input  className="u-full-width" type="text" value={this.state.unsubscribeBroadcastId}  onChange={(event) => this.setState({unsubscribeBroadcastId: event.target.value})} /><br />
                  Filter: <textarea  className="u-full-width" value={this.state.unsubscribeFilter} onChange={(event) => this.setState({unsubscribeFilter: event.target.value})} /><br/>
                  <button className="button-primary"  onClick={this.unsubscribe.bind(this)}>Unsubscribe</button>
                </div>
                <hr/>
                <div>
                  <h4>Publish to Broadcast</h4><br />
                  BroadcastId: <input  className="u-full-width" type="text" value={this.state.broadcastBroadcastId}  onChange={(event) => this.setState({broadcastBroadcastId: event.target.value})} /><br />
                  Token:<input  className="u-full-width" type="text" value={this.state.broadcastToken}  onChange={(event) => this.setState({broadcastToken: event.target.value})} /><br />
                  Broadcast JSON data: <textarea  className="u-full-width" value={this.state.broadcastData} onChange={(event) => this.setState({broadcastData: event.target.value})} />
                  <button className="button-primary"  onClick={this.broadcast.bind(this)}>Publish to broadcastId</button>
                </div>
                <div>
                  <h4>Create Stream (using QS)</h4><br />
                  Query: <textarea  className="u-full-width" value={this.state.qsQuery} onChange={(event) => this.setState({qsQuery: event.target.value})} />
                  Destination: <textarea  className="u-full-width bigtextarea" value={JSON.stringify(this.state.destination, null, 2)} onChange={(event) => this.setState({destination: JSON.parse(event.target.value)})} />
                  Config: <textarea  className="u-full-width" value={this.state.qsConfig} onChange={(event) => this.setState({qsConfig: event.target.value})} />
                  Meta: <textarea  className="u-full-width" value={this.state.qsMeta} onChange={(event) => this.setState({qsMeta: event.target.value})} />
                  <button className="button-primary"  onClick={this.createStream.bind(this)}>Create Stream</button>
                </div>
                <div>
                  <h4>Delete Stream (using QS)</h4><br />
                  Last Created Stream id: <input  className="u-full-width" type="text" value={this.state.qsLastCreatedStreamId}  onChange={(event) => this.setState({qsLastCreatedStreamId: event.target.value})} /><br />
                  <button className="button-primary"  onClick={this.deleteStream.bind(this)}>Delete Stream</button>
                </div>
                <div>
                  <h4>Push to stream provider</h4>
                  Data: <textarea className="u-full-width bigtextarea" value={this.state.qsNotifyData} onChange={(event) => this.setState({qsNotifyData: event.target.value})} /><br/>
                  <button className="button-primary"  onClick={this.publishToStream.bind(this)}>Publish</button>
                </div>
              </div>
              <div className="two">
                <div>
                  <b>Request result:</b> {this.state.result}
                </div>
                <hr />
                { this.state.messages.map((msg, index) => <div key={index}> <b>Message {this.state.messages.length-index}</b>: <pre>{msg}</pre></div>)}
              </div>
          </section>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js